export const TOWER_DEPROP_1 = 'Deprop 1'
export const TOWER_DEPROP_2 = 'Deprop 2'
export const TOWER_DEPROP_3 = 'Deprop 3'
export const TOWER_DEPROP_4 = 'Deprop 4'
export const TOWER_DEBUT_1 = 'Debut 1'
export const TOWER_DEBUT_3 = 'Debut 3'
export const TOWER_DEBUT_4 = 'Debut 4'
export const TOWER_SPLITTER_1 = 'Splitter 1'
export const TOWER_SPLITTER_3 = 'Splitter 3'
export const TOWER_SPLITTER_4 = 'Splitter 4'
export const TOWER_SPLITTER_6 = 'Splitter 6'
export const TOWER_UPGRADER = 'Upgrader'

export const TOWER_DEPROP_1_Reason = 'TOWER_DEPROP_1_Reason'
export const TOWER_DEPROP_2_Reason = 'TOWER_DEPROP_2_Reason'
export const TOWER_DEPROP_3_Reason = 'TOWER_DEPROP_3_Reason'
export const TOWER_DEPROP_4_Reason = 'TOWER_DEPROP_4_Reason'
export const TOWER_DEBUT_1_Reason = 'TOWER_DEBUT_1_Reason'
export const TOWER_DEBUT_3_Reason = 'TOWER_DEBUT_3_Reason'
export const TOWER_DEBUT_4_Reason = 'TOWER_DEBUT_4_Reason'
export const TOWER_SPLITTER_1_Reason = 'TOWER_SPLITTER_1_Reason'
export const TOWER_SPLITTER_3_Reason = 'TOWER_SPLITTER_3_Reason'
export const TOWER_SPLITTER_4_Reason = 'TOWER_SPLITTER_4_Reason'
export const TOWER_SPLITTER_6_Reason = 'TOWER_SPLITTER_6_Reason'
export const TOWER_UPGRADER_Reason = 'TOWER_UPGRADER_Reason'

export const TOWER_DEPROP_1_HoursOffline = 'TOWER_DEPROP_1_HoursOffline'
export const TOWER_DEPROP_2_HoursOffline = 'TOWER_DEPROP_2_HoursOffline'
export const TOWER_DEPROP_3_HoursOffline = 'TOWER_DEPROP_3_HoursOffline'
export const TOWER_DEPROP_4_HoursOffline = 'TOWER_DEPROP_4_HoursOffline'
export const TOWER_DEBUT_1_HoursOffline = 'TOWER_DEBUT_1_HoursOffline'
export const TOWER_DEBUT_3_HoursOffline = 'TOWER_DEBUT_3_HoursOffline'
export const TOWER_DEBUT_4_HoursOffline = 'TOWER_DEBUT_4_HoursOffline'
export const TOWER_SPLITTER_1_HoursOffline = 'TOWER_SPLITTER_1_HoursOffline'
export const TOWER_SPLITTER_3_HoursOffline = 'TOWER_SPLITTER_3_HoursOffline'
export const TOWER_SPLITTER_4_HoursOffline = 'TOWER_SPLITTER_4_HoursOffline'
export const TOWER_SPLITTER_6_HoursOffline = 'TOWER_SPLITTER_6_HoursOffline'
export const TOWER_UPGRADER_HoursOffline = 'TOWER_UPGRADER_HoursOffline'

export const TOWER_DEPROP_1_ADJHRSOFFLINE = 'TOWER_DEPROP_1_ADJHRSOFFLINE'
export const TOWER_DEPROP_2_ADJHRSOFFLINE = 'TOWER_DEPROP_2_ADJHRSOFFLINE'
export const TOWER_DEPROP_3_ADJHRSOFFLINE = 'TOWER_DEPROP_3_ADJHRSOFFLINE'
export const TOWER_DEPROP_4_ADJHRSOFFLINE = 'TOWER_DEPROP_4_ADJHRSOFFLINE'
export const TOWER_DEBUT_1_ADJHRSOFFLINE = 'TOWER_DEBUT_1_ADJHRSOFFLINE'
export const TOWER_DEBUT_3_ADJHRSOFFLINE = 'TOWER_DEBUT_3_ADJHRSOFFLINE'
export const TOWER_DEBUT_4_ADJHRSOFFLINE = 'TOWER_DEBUT_4_ADJHRSOFFLINE'
export const TOWER_SPLITTER_1_ADJHRSOFFLINE = 'TOWER_SPLITTER_1_ADJHRSOFFLINE'
export const TOWER_SPLITTER_3_ADJHRSOFFLINE = 'TOWER_SPLITTER_3_ADJHRSOFFLINE'
export const TOWER_SPLITTER_4_ADJHRSOFFLINE = 'TOWER_SPLITTER_4_ADJHRSOFFLINE'
export const TOWER_SPLITTER_6_ADJHRSOFFLINE = 'TOWER_SPLITTER_6_ADJHRSOFFLINE'
export const TOWER_UPGRADER_ADJHRSOFFLINE = 'TOWER_UPGRADER_ADJHRSOFFLINE'